import React from "react";
import image_503 from "./503.svg";
import "./ServerErrorPage.scss";


const ServerErrorPage: React.VFC = () => {
  const message = "This service is currently undergoing maintenance.";
  return (
    <div
      className={"d-flex flex-column serverPageError"}
      style={{ height: "calc(100vh - 128px)", paddingTop: "160px" }}
    >
      <section className={"section2"}>
        <div className={`container-fluid ${"containerFluid"}`}>
          <div className={`container ${"mainWrapper"}`}>
            <div className="row">
              <div className="col-lg-2 bg-white pt-5 pb-4 py-lg-0">
                <span
                  className="d-block d-md-none text-outline-socgen text-primary-alt font-weight-medium"
                  style={{
                    fontSize: "56px",
                    fontFamily: "Neue Haas Grotesk W04 Disp",
                  }}
                >
                  503
                </span>
                <span
                  className="d-none d-md-block d-lg-none text-outline-socgen text-primary-alt font-weight-medium"
                  style={{
                    lineHeight: "1.2",
                    fontSize: "56px",
                    fontFamily: "Neue Haas Grotesk W04 Disp",
                  }}
                >
                  503
                </span>
                <span className="mt-n2 d-none d-lg-inline-block d-xl-none display-2 text-outline-socgen text-primary-alt font-weight-medium">
                  503
                </span>
                <span
                  className="mt-n3 d-none d-xl-block display-1 text-outline-socgen text-primary-alt font-weight-medium"
                  style={{ fontSize: "96px", overflow: "hidden" }}
                >
                  503
                </span>
              </div>
              <div className="col-lg-5  bg-white d-flex flex-column justify-content-between">
                <div>
                  <h1 className="d-none d-lg-block display-2 font-weight-medium line-height-1 pt-0 pb-3">
                    {"We'll be back shortly."}
                  </h1>
                  <h1 className="d-lg-none display-3 font-weight-medium line-height-1 py-2">
                    {"Something's wrong."}
                  </h1>
                  <p className="d-lg-none mb-5 h3 font-weight-medium text-secondary line-height-1">
                    {message}
                  </p>
                  <p className="d-none d-lg-block d-xxl-none display-3 font-weight-medium text-secondary w-75 line-height-1">
                    {message}
                  </p>
                  <p className="d-none d-xxl-block display-3 font-weight-medium text-secondary w-75 line-height-1">
                    {message}
                  </p>
                </div>
                <div className="mb-5 d-none d-md-flex">
                  <a href={"/"} className="btn btn-xl btn-primary border-0">
                    Go back
                  </a>
                  <a
                    href="mailto:gbis-cdo-dx-help.world@sgcib.com"
                    className="btn btn-xl btn-flat-secondary ml-1 border-0"
                  >
                    Contact us
                  </a>
                </div>
                <div className="d-block d-md-none">
                  <a
                    href={"/"}
                    className="btn btn-xl btn-primary btn-block mb-1 border-0"
                  >
                    Go back
                  </a>
                  <a
                    href="mailto:gbis-cdo-dx-help.world@sgcib.com"
                    className="btn btn-xl btn-flat-secondary ml-1 btn-block border-0"
                  >
                    Contact us
                  </a>
                </div>
              </div>
              <div className="col-4 px-0 position-relative">
                <div
                  className="d-none d-lg-block"
                  style={{
                    paddingTop: "100%",
                    backgroundImage: `url(${image_503})`,
                    backgroundColor: "#fff",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "130%",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={`flex-grow-1 d-flex ${"section3"}`}>
        <div className={`container-fluid ${"containerFluid"}`}>
          <div className="container h-100 d-none d-lg-block">
            <div className="row h-100">
              <div
                className="offset-2 col-5 pt-5 text-muted"
                style={{ backgroundColor: "#fafafa" }}
              >
                © Societe Generale Group {new Date().getFullYear()}
              </div>
            </div>
          </div>
          <footer
            className={`${"containerFluid"} container-fluid d-lg-none position-absolute text-muted`}
            style={{ bottom: 0, left: 0, right: 0, backgroundColor: "#fafafa" }}
          >
            <div className="container py-4">
              © Societe Generale Group {new Date().getFullYear()}
            </div>
          </footer>
        </div>
      </section>
    </div>
  );
};

export default ServerErrorPage;
